import { SurveyAnswerBody } from "../types/working-model";
import { HvHostMap, PostHv } from "./helpers";

export const SubmitSurveyAnswer = async (body: SurveyAnswerBody, token?: string | null): Promise<any> => {
	return PostHv(HvHostMap.surveys, '/e3-submit-survey', { ...body }, token || '');
};
